import React from "react";
import { Sparkles } from "lucide-react";
import { FX_PRESETS, DEFAULT_FX, fxFilterCss } from "@/lib/mediaFx";

// Lot 639 — bandeau de filtres du studio mobile : mêmes presets (et mêmes vignettes) que la caméra intégrée
// (StoryCamera). La vignette est l'avatar de l'hôte quand il en a un, sinon un dégradé — l'aperçu caméra natif
// n'est pas capturable depuis la page.
// Lot 642 — première vignette « Beauté » (ouvre le curseur d'intensité), disponible aussi PENDANT le direct natif.
const SWATCH = "linear-gradient(135deg, #f6d365 0%, #fda085 45%, #5ee7df 100%)";

export const LiveFxStrip = ({ value, onPick, thumbSrc, t, beauty = 0, onBeauty, beautyEnabled = false }) => (
  <div className="flex gap-3 overflow-x-auto hide-scrollbar px-1 py-1" role="radiogroup" data-testid="live-fx-strip" data-value={value}>
    {beautyEnabled && onBeauty && (
      <button type="button" onClick={onBeauty} className="shrink-0 flex flex-col items-center gap-1 w-[56px]" data-testid="live-fx-beauty" data-on={beauty > 0 ? 1 : 0} aria-label={t("studio.beauty_filter", "Filtre beauté")}>
        <span className="h-12 w-12 rounded-full grid place-items-center border-2 transition-transform" style={{ borderColor: beauty > 0 ? "#D97757" : "rgba(255,255,255,.45)", background: beauty > 0 ? "#D97757" : "rgba(255,255,255,0.2)", color: "#fff", transform: beauty > 0 ? "scale(1.1)" : "none" }}>
          <Sparkles size={20} />
        </span>
        <span className={`text-[10px] leading-none truncate w-full text-center ${beauty > 0 ? "font-bold text-white" : "text-white/75"}`}>{beauty > 0 ? `${beauty} %` : t("studio.beauty_off", "Beauté")}</span>
      </button>
    )}
    {FX_PRESETS.map((p) => {
      const on = value === p.key;
      const filter = fxFilterCss({ ...DEFAULT_FX, preset: p.key });
      return (
        <button key={p.key} type="button" role="radio" aria-checked={on} onClick={() => onPick(p.key)} className="shrink-0 flex flex-col items-center gap-1 w-[56px]" data-testid={`live-fx-${p.key}`} data-on={on ? 1 : 0}>
          <span className="h-12 w-12 rounded-full overflow-hidden border-2 bg-white/20 transition-transform" style={{ borderColor: on ? "#D97757" : "rgba(255,255,255,.45)", transform: on ? "scale(1.1)" : "none" }}>
            {thumbSrc
              ? <img src={thumbSrc} alt="" className="h-full w-full object-cover" style={{ filter }} draggable={false} />
              : <span className="block h-full w-full" style={{ background: SWATCH, filter }} />}
          </span>
          <span className={`text-[10px] leading-none truncate w-full text-center ${on ? "font-bold text-white" : "text-white/75"}`}>{t(`fx.preset_${p.key}`, p.label)}</span>
        </button>
      );
    })}
  </div>
);

export default LiveFxStrip;
